// $(document).ready(function($){
//   $(document).on('click', '.product-grid-item__content .icon-heart', function(){
//       $(this).toggleClass('active');
//   });
// })

// document.addEventListener('DOMContentLoaded', function() {
   
//   document.addEventListener('click', function(event) {
//         var target = event.target;
//         if (target && target.matches('.product-grid-item__content button')) {
//             target.classList.toggle('active');
//         }
//     });
// });


const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

document.addEventListener('DOMContentLoaded', () => {
  // initButtons();
  initGrid();
  if (document.querySelector('._wishlistpage')) {
        // Call the function
        setTimeout(function(){initButtons();}, 2500);
    }else{
      initButtons()
    }
  
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    // if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
   wishlistContains(productHandle)
      .then(containsProduct => {
        if (containsProduct) button.classList.add(BUTTON_ACTIVE_CLASS);
      })
      .catch(error => {
        console.error('Error checking if wishlist contains productHandle:', error);
      });
    button.addEventListener('click', (event) => {

      if (button.classList.contains('_notCutomer')) {
          var loginPopup = document.getElementById("loginPopup");
          event.preventDefault();
          loginPopup.style.display = "block";
          localStorage.setItem('articalTempId', productHandle);
          return;
      } 
       
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};




const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};
// document.addEventListener('DOMContentLoaded', () => {
//     const buttons = document.querySelectorAll(selectors.button) || [];
//     if (buttons.length) {
//         setupButtons(buttons);
//     }
// });


// const getWishlist = () => {
//   const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;

//       var customerId = document.getElementById('CustomerLoginForm')
//       var customerId = customerId.getAttribute('data-cid');
      
//       if (customerId != "") {
//         console.log(customerId);
//         var url = 'http://knatteplock.looplabzdemos.com/update-wishlist/?getWl=true&customerId='+customerId;
//           fetch(url, {
//               method: 'GET',
            
//           })
//           .then(response => {
//               if (!response.ok) {
//                   throw new Error('Network response was not ok');
//               }
//               return response.json();
//           })
//           .then(data => {
//               wishlist = data.metafields[0].value;
//               if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
//           })
//           .catch(error => {
//               console.error('Error getting list '+ error);
//           });
//       }
//   if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
//   return [];
// };

const getWishlist = () => {
    return new Promise((resolve, reject) => {
        // const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;

        var customerId = document.getElementById('CustomerLoginForm').getAttribute('data-cid');

        if (customerId && customerId !== "") {
            var url = 'http://knatteplock.looplabzdemos.com/update-wishlist/?getWl=true&customerId=' + customerId;
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (data && data.metafields && data.metafields.length > 0) {
                        const wishlistFromServer = data.metafields[0].value;
                        const parsedWishlist = wishlistFromServer.split(LOCAL_STORAGE_DELIMITER);
                        console.log(parsedWishlist);
                        resolve(parsedWishlist);
                    } else {
                        resolve([]);
                    }
                })
                .catch(error => {
                    console.error('Error getting list ' + error);
                    reject(error);
                });
        } else {
            resolve(wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : []);
        }
    });
};

// github

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

   // if (array.length){
      var customerId = document.getElementById('CustomerLoginForm')
      var customerId = customerId.getAttribute('data-cid');
     
      if (customerId != "") {
        console.log(customerId);
        var url = 'http://knatteplock.looplabzdemos.com/update-wishlist/?list='+wishlist+'&customerId='+customerId;
        if (array.length === 0){
          var url = 'http://knatteplock.looplabzdemos.com/update-wishlist/?list=-&customerId='+customerId;
        }
          fetch(url, {
              method: 'GET',
            
          })
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.json();
          })
          .then(data => {
              console.log('scessfully updated list: '+data);
          })
          .catch(error => {
              console.error('Error updating list '+ error);
          });
      }
    // }

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

// const updateWishlist = (handle) => {
//   const wishlist = getWishlist();
//   const indexInWishlist = wishlist.indexOf(handle);
//   if (indexInWishlist === -1) wishlist.push(handle);
//   else wishlist.splice(indexInWishlist, 1);
//   return setWishlist(wishlist);
// };


const updateWishlist = async (handle) => {
  try {
    let wishlist = await getWishlist(); // Wait for getWishlist() to resolve
    const indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1){
      wishlist.push(handle);
    } else{
      if(localStorage.getItem('articalTempId') === null){
        wishlist.splice(indexInWishlist, 1);
      }
    } 

    console.log(wishlist)
    return setWishlist(wishlist);
  } catch (error) {
    console.error('Error updating wishlist:', error);
    return false;
  }
};


// const wishlistContains = (handle) => {
//   const wishlist = getWishlist();
//   return wishlist.includes(handle);
// };

const wishlistContains = async (handle) => {
    try {
        const wishlist = await getWishlist();
        return wishlist.includes(handle);
    } catch (error) {
        console.error('Error checking if wishlist contains handle:', error);
        return false; // Return false if an error occurs
    }
};

const resetWishlist = () => {
  return setWishlist([]);
};
document.addEventListener('click', function(event) {
    var loginPopup = document.getElementById('loginPopup');
    var targetElement = event.target;
      if (loginPopup && !loginPopup.contains(targetElement) && !targetElement.closest('._wishlistIcon') && !targetElement.closest('._notCutomerpp')) {
        closeLoginPopup();
    }
});

function closeLoginPopup() {
    var loginPopup = document.getElementById('loginPopup');
    loginPopup.style.display = 'none';
    loginPopup.classList.remove('show');
}

document.addEventListener('DOMContentLoaded', function() {
    var passwordInput = document.getElementById('CustomerPassword');
    var passwordShowButton = document.getElementById('CustomerPasswordShow');

    passwordShowButton.addEventListener('click', function() {
        if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
        } else {
            passwordInput.type = 'password';
        }
    });
});


 function addItemToCart(item) {
    var formData = new FormData();
    formData.append('quantity', 1);
    formData.append('id', item.itemId);
    formData.append('product-id', item.productId);
    formData.append('form_type', 'product');
    formData.append('utf8', '✓');
    formData.append('section-id', 'template--20741844468057__main');

    return fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (response.ok) {
            // Item added successfully
            console.log('Item with variant ID ' + item.itemId + ' added to cart');
            return response.json(); // Parse response data if needed
        } else {
            // Error adding item to cart
            console.error('Error adding item with variant ID ' + item.itemId + ' to cart');
            throw new Error('Error adding item to cart');
        }
    })
    .catch(error => {
        console.error('Error adding item with variant ID ' + item.itemId + ' to cart:', error);
        throw error; // Propagate the error
    });
}



var _wishlistBtn = document.getElementsByClassName('_wishlistIcon')[0];
if(_wishlistBtn){
  var infoValue = _wishlistBtn.getAttribute('data-info');
  console.log(infoValue);
  if (infoValue == "logedin") {
      if(localStorage.getItem('articalTempId')){
        updateWishlist(localStorage.getItem('articalTempId'));
        const buttons2 = document.querySelectorAll('button._wishlistIcon');
        const articleTempId = localStorage.getItem('articalTempId');
        localStorage.removeItem('articalTempId');
      // Iterate over each button
        buttons2.forEach(button => {
            // Check if the data-product-handle attribute matches articleTempId
            if (button.getAttribute('data-product-handle') === articleTempId) {
                // If it matches, add the active class to the button
                button.classList.add('active');
            }
        });
          
        
      }
  }
}


var loginBtns = document.getElementsByClassName('_notCutomerpp');

for (var i = 0; i < loginBtns.length; i++) {
    loginBtns[i].addEventListener('click', function(event) {
        event.preventDefault();
        var loginPopup = document.getElementById("loginPopup");
        if (loginPopup) {
            console.log("loginPopup element found:", loginPopup);
            // Add a CSS class to make the popup visible
            loginPopup.classList.add('show');
        } else {
            console.log("loginPopup element not found.");
        }
    });
}